import { Building2, Home, Settings } from "lucide-react";

export const ITENS_PLATFORM_ADMIN = [
  { href: "/programador/inicio", label: "Início", Icon: Home },
  { href: "/programador", label: "Empresas", Icon: Building2 },
  { href: "/configuracoes", label: "Configurações", Icon: Settings },
] as const;

export function itemPlatformAdminAtivo(pathname: string, href: string) {
  if (href === "/programador") return pathname === href;
  return pathname === href || pathname.startsWith(`${href}/`);
}
